import { useCallback, useContext } from 'react';

import { SankeyHoverStoreContext } from '../context/SankeyHoverStore.context.js';
import type { SankeyHoveredShape } from '../types/sankey-hover.js';

const useSetState = () => {
  const { setState } = useContext(SankeyHoverStoreContext);

  return setState;
};

export const useSetHoveredShape = () => {
  const setState = useSetState();

  return useCallback(
    (shape: SankeyHoveredShape) => {
      setState((prev) => ({ ...prev, hovered: shape }));
    },
    [setState],
  );
};

export const useClearHoveredShape = () => {
  const setState = useSetState();

  return useCallback(() => {
    setState((prev) => ({ ...prev, hovered: undefined }));
  }, [setState]);
};
